/* This file is generated by scripts/write-build-version.js. */
export const BUILD_ID = "6ae7c3f24bdd";
export const BUILD_COMMIT = "";
export const BUILD_SOURCE_HASH = "6ae7c3f24bdd";
export const BUILD_BUILT_AT = "2026-10-31T14:41:39.735Z";
